/**
 * Created by Rodrigo Quesada on 16/03/17.
 */
import {Injectable} from '@angular/core';

@Injectable()
export class NavigationService {

    private _keyboardNavigationIsEnabled: boolean = true;
    get keyboardNavigationIsEnabled(): boolean { return this._keyboardNavigationIsEnabled; }

    disableKeyboardNavigation() {
        this._keyboardNavigationIsEnabled = false;
    }

    enableKeyboardNavigation() {
        this._keyboardNavigationIsEnabled = true;
    }

    unsavedDataDiscardingConfirmationMessage(): string {
        return 'The form has not been saved, are you sure you want to continue?';
    }

    confirmUnsavedDataDiscarding(): boolean {
        return confirm(this.unsavedDataDiscardingConfirmationMessage());
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/navigation/service/navigation.service.ts